import script from "./CalendarModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarModal.vue?vue&type=script&setup=true&lang=js"

import "./CalendarModal.vue?vue&type=style&index=0&id=712c2088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712c2088"]])

export default __exports__